import * as _4 from 'lodash4';
import { PlannedCourseGroup } from '../../../../../global/builders/planned_course_group_builder';

class PreviewTermPlanCourseGroupTileController {
  private plannedCourseGroup: PlannedCourseGroup;
  private plannedCourseGrpDesc: string;
  private courseGroupTileId: string;

  initialize() {
    this.plannedCourseGrpDesc = _4.get(this.plannedCourseGroup, 'program_slot_obj.desc');
    this.courseGroupTileId = `preview-term-plan-course-group-tile-${_4.uniqueId()}`;
  }
  $onInit = () => this.initialize();
  $onChanges = () => this.initialize();
}

angular.module('capability-ng-academic-planner').component('previewTermPlanCourseGroupTile', {
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_term_plan_course_group_tile/preview_term_plan_course_group_tile.html',
  bindings: {
    plannedCourseGroup: '='
  },
  controller: PreviewTermPlanCourseGroupTileController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_term_plan_course_group_tile/preview_term_plan_course_group_tile.ts